import { Tooltip } from "primereact/tooltip";
import { useLocation } from "react-router-dom";
interface NavigationIconProps {
  showConversationPane: boolean;
  isOpen: boolean;
  success: boolean;
  activeSidebar: string | null;
  navigationIcon: string;
  handleSidebarToggle: (value: boolean) => void;
}

const NavigationIcon: React.FC<NavigationIconProps> = ({ showConversationPane, isOpen, success, activeSidebar, navigationIcon, handleSidebarToggle }) => {
   const location = useLocation();
  const isSkillsRoute = location.pathname.startsWith("/app") || location.pathname.startsWith("/skills");
  const isAdminRoute = location.pathname.startsWith("/admin");

  if (isSkillsRoute || isAdminRoute) {
    return null;
  }
  // Early return if conditions aren't met
  if (!(showConversationPane && !isOpen && success && activeSidebar === null)) {
    return null;
  }

  return (
    <div className="navigation-icon-container">
      <Tooltip target=".navigation-icon" content="Navigation" position="right" />
      <img
        src={navigationIcon}
        alt="Navigation Icon"
        width="26"
        onClick={() => handleSidebarToggle(true)}
        className="cursor-pointer navigation-icon"
      />
    </div>
  );
};

export default NavigationIcon;
